import { type FC, memo } from 'react';
import SegmentedControl from 'SegmentedControl';
import { useNavigate, useParams } from 'react-router-dom';
import { Curriculum } from './Curriculum';
import { CurrentlyStudying } from './CurrentlyStudying';
import { isValidDashboardTab } from './typeGuards';

const tabs = [
    {
        title: 'Currently Studying',
        key: 'currently-studying',
        content: <CurrentlyStudying />,
    },
    {
        title: 'Curriculum',
        key: 'curriculum',
        content: <Curriculum />,
    },
] as const;

const StudyBoxComponent: FC = () => {
    const { studyTab } = useParams();
    const navigate = useNavigate();

    // FIXME: We probably want to wrap this in a Card component (maybe with padding=0)
    return (
        <div className="min-h-[840px] rounded border border-gray-300 bg-white">
            <SegmentedControl
                classNames={{
                    panel: 'h-[781px]',
                    base: 'mt-5',
                }}
                segments={tabs}
                selectedSegment={isValidDashboardTab(studyTab) ? studyTab : tabs[0].key}
                onSegmentChange={key => {
                    // Don't trigger navigation if the current tab is already selected
                    if (key === studyTab) return;

                    navigate(`/dashboard/${key}`);
                }}
            />
        </div>
    );
};

export const StudyBox = memo(StudyBoxComponent) as typeof StudyBoxComponent;
